import { Common } from 'ws-scripts/modules/common';
import React from 'react';
import {isNode} from 'ws-scripts/modules/environment';
import './Progress.scss';


const Progress = () => {
	const circleWidth = 4;
	const handWidth = 4;
	const height = 80;
	const width = 64;
	const percentExists = (!isNode && window.DDC.digitalRetailing.percentVehicleComplete !== undefined);	

	return (
		<Common
			render={({ labels }) => {
				return (
					<div className="row">
						<div className="col-sm-3 digital-retailing-progress circle-progress">
							<canvas
								className="dr-clock tool-box-clock"
								data-circle-width={circleWidth}
								data-hand-width={handWidth}
								height={height}
								width={width}
							/>
							<div className="circle-color hidden" />
							<div className="progress-color hidden" />
							<div className="fill-color hidden" />
							<div className="enable-percent-indicator">	
								<div className="percentage">{ percentExists && `${Math.round(window.DDC.digitalRetailing.percentVehicleComplete * 100.0)}%`}</div>
							</div>
						</div>
						<div className="col-sm-9 intro-text-container">
							<p
								data-dr-progress-start-text
								data-show-on-state="start"
							>
								{ labels.get(
									'WS_DR_TOOLBOX_START_VERBIAGE'
								)}
							</p>
							<p
								data-dr-progress-text
								data-show-on-state="progress"
								className="hide"
							>
								{labels.get(
									'WS_DR_TOOLBOX_PROGRESS_VERBIAGE'
								)}
							</p>
							<p
								data-dr-progress-complete-text
								data-show-on-state="complete"
								className="hide"
							>
								{labels.get(
									'WS_DR_TOOLBOX_COMPLETE_VERBIAGE'
								)}
							</p>
						</div>
					</div>
				);
			}}
		/>
	);	
};

export default Progress; 



// WEBPACK FOOTER //
// ./src/components/Progress.jsx